import AnnualDataQualityMeasurementIntegrity from "./AnnualDataQualityMeasurementIntegrity";

const AnnualVolumeThroughputDemandForecast = (props) => (
  <AnnualDataQualityMeasurementIntegrity
    {...props}
    title="Annual Volume, Throughput, and Demand Forecast"
    description="Annual demand and throughput envelope with monthly seasonality, branch/service ranking, peak periods, and forecast confidence."
    emptyTableText="No annual volume or forecast tables were supplied."
  />
);

export default AnnualVolumeThroughputDemandForecast;
